import React from 'react';
import './styles.css';
import '../components/elements/CosmicVoyage.css';
import Landing from '../components/elements/Landing';
import LandingSecond from '../components/elements/Landing2';
import Carousel from '../components/elements/EventCarousal'; // Update the import path
import Card from "../components/elements/card"; // Add the correct import path for Card
import { events } from '../events';
import Footer from '../components/elements/footer';

const Home = () => {

  const eventCards = events
    .filter(event => event.path !== '/workshop')  
    .map(event => (
      <Card
        key={event.path} // Unique key for each Card
        title={event.name}
        content={event.sh_desc}
        logo={event.imageSrc}
        path={event.path}
      />
    ));

  return (
    <div className="home-container scroll-smooth h-screen snap-y snap-mandatory overflow-y-scroll">
      <section className="section relative h-screen snap-start">
  <div>
    <Landing />
  </div>
</section>

      <section className="section relative h-screen snap-start">
        <div className="star-field" id="starField"></div>
        <div className="ag-dragon-fly-block">
          <div className="ag-dragon"></div>
          <div className="ag-dragon-small"></div>
          <div className="ag-dragon"></div>
          <div className="ag-dragon-small"></div>
          <div className="ag-dragon"></div>
        </div>
        <LandingSecond />
      </section>

      <section className="section relative h-screen snap-start flex flex-col items-center justify-center">
        <div className="ag-dragon-fly-block">
          <div className="ag-dragon-small"></div>
          <div className="ag-dragon"></div>
          <div className="ag-dragon"></div>
        </div>
        <div className='flex justify-center p-8 m-8 text-center w-screen flex-col items-center'>
          <h1 className='text-slate-100 z-10 pb-16 text-5xl md:text-6xl lg:text-7xl event-title-main text-7xl font-[GOT] event-title-sub'
            style={{ WebkitTextStroke: '2px black' }}>
            Events
          </h1>
          <Carousel>
            {eventCards}
          </Carousel>
        </div>
      </section>

      <section className="section relative h-screen snap-start flex flex-col items-center justify-center">
        <div className="ag-dragon-fly-block">
          <div className="ag-dragon-small"></div>
          <div className="ag-dragon"></div>
          <div className="ag-dragon"></div>
        </div>
        <div className='flex flex-col items-center text-center w-screen'>
          <h1 className='text-white z-10 pb-16 event-title-main 
              text-5xl md:text-6xl lg:text-7xl 
              font-[GOT] event-title-sub'
            style={{ WebkitTextStroke: '2px black' }}>
            Workshop
          </h1>

          <Carousel>
            <Card
              key={events[8].path} // Unique key for each Card
              title={events[8].name}
              content={events[8].sh_desc}
              logo={events[8].imageSrc}
              path={events[8].path}
            />
          </Carousel>
        </div>
      </section>
    </div>
  );
};

export default Home;
